import { render } from "./printPrescription.vue?vue&type=template&id=01fd6d66&scoped=true"
import script from "./printPrescription.vue?vue&type=script&lang=js"
export * from "./printPrescription.vue?vue&type=script&lang=js"

import "./printPrescription.vue?vue&type=style&index=0&id=01fd6d66&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-01fd6d66"

export default script